

















import Vue from 'vue';
import { BFormRadioGroup } from 'bootstrap-vue';

export default Vue.extend({
  name: 'EditCardRadio',
  components: {
    BFormRadioGroup,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
});
